export default __webpack_public_path__ + "static/media/banner-2.c7e70108.jpg";